import * as yup from "yup";

const DEFAULT_MESSAGE = "Este campo es requerido."

const settingsSchema = yup.object().shape({
    app_ads_per_news: yup.number().moreThan(0,DEFAULT_MESSAGE).required(DEFAULT_MESSAGE),
    facebook_url: yup.string().required(DEFAULT_MESSAGE),
    tiktok_url: yup.string().required(DEFAULT_MESSAGE),
    youtube_url: yup.string().required(DEFAULT_MESSAGE),
    instagram_url: yup.string().required(DEFAULT_MESSAGE),
    twitter_url: yup.string().required(DEFAULT_MESSAGE),
    video_streaming: yup.string().required(DEFAULT_MESSAGE),
    video_streaming_active: yup.boolean().required(DEFAULT_MESSAGE)
});

export {
    settingsSchema
}